import React, { forwardRef } from 'react';
import { NavLink as NavLinkDefault, NavLinkProps } from 'react-router-dom';
import { buildLinkTo } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(({
  to,
  ...props
}, forwardedRef) => <NavLinkDefault to={buildLinkTo(to, app.getLang())} ref={forwardedRef} {...props} />);

export { NavLink };
